module.exports = __webpack_public_path__ + "static/media/rgPrint.d930ade5.png";